import React from "react";
import { CSVLink } from "react-csv";

const tableColumn = [
  "Tin",
  "Customer",
  "Company",
  "Phone",
  "Email",
  "Country",
  "Type",
  "Status",
];

function getRows(data) {
  return data && data.length > 0
    ? data.map((row) => {
        const customerName =
          row.first_name && row.last_name
            ? `${row.first_name} ${row.last_name}`
            : "--";
        const type = row.type === "individual" ? "Individual" : "Company";
        const status = row.status === true ? "Active" : "Inactive";

        return [
          row.tin || "--",
          customerName,
          row.company_name || "--",
          row.mobile_no || "--",
          row.email || "--",
          row.country || "--",
          type,
          status,
        ];
      })
    : [["No data"]];
}

const CustomerCsv = ({ data, csvLinkRef }) => {
  let csvData = [];
  csvData.push(["CUSTOMER LIST"]);
  csvData.push([]);
  csvData.push(tableColumn);
  csvData = csvData.concat(getRows(data));

  return (
    <div>
      <CSVLink
        data={csvData}
        filename={"Customer.csv"}
        className="text-decoration-none text-reset"
        target="_blank"
        ref={csvLinkRef}
      ></CSVLink>
    </div>
  );
};

export default CustomerCsv;
